import React, { Component, Fragment, useReducer } from "react";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { getTypeOfAdjFormDataRows, SFRTA_TrackDisturbanceReportSectionsSchema } from "./SFRTA_TrackDisturbanceReportSectionsSchema";
import { TickBoxOptions } from "../../../../libraries/ReportGenerator/TickBox";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";

const { typeOfAdjustmentDisturbance } = SFRTA_TrackDisturbanceReportSectionsSchema;

export const SpecialKeyValComboBox = ({ rows, data, titleAlign, style }) => {
  const getRow = (row, i) => {
    const { columns, height } = row;
    return (
      <tr style={height ? { height: height } : {}}>
        {columns.map((property, j) => {
          const { title, titleColSpan, valId, valueColSpan, formatter } = property;
          return (
            <Fragment key={`${i}+${j}`}>
              <td
                colSpan={titleColSpan}
                className={"pd-left-10px pd-right-10px bold-text"}
                style={{ textAlign: titleAlign ? titleAlign : "center" }}
              >
                {title ? `${title}:` : ""}
              </td>
              <td colSpan={valueColSpan} className={"pd-left-10px pd-right-10px text-left"}>
                {formatter ? formatter(data[valId]) : data[valId]}
              </td>
            </Fragment>
          );
        })}
      </tr>
    );
  };

  return (
    <div style={style ? style : {}}>
      <table style={{ paddingLeft: "35px", width: "100%", paddingRight: "35px" }}>
        <tbody>
          {rows.map((row, i) => {
            return getRow(row, i);
          })}
        </tbody>
      </table>
    </div>
  );
};

export function createGroups(arr, perGroup) {
  const numGroups = Math.ceil(arr.length / perGroup);
  return new Array(numGroups).fill("").map((_, i) => arr.slice(i * perGroup, (i + 1) * perGroup));
}

const SectionHeader = ({ title }) => {
  return <div style={{ padding: "0 10px 10px", fontSize: "20px", fontWeight: 600 }}>{title}</div>;
};

class ReportView extends Component {
  render() {
    let reportData = this.props.reportData ? this.props.reportData : {};
    let { location, user, date, formSummary, isMaintenance, subdivision } = reportData;
    if (!formSummary) formSummary = {};

    let data = {
      lineName: subdivision,
      location: location,
      user: user ? user.name : "",
      reportDate: dataFormatters.dateFormatter(date),
      ...formSummary,
    };

    let reportTitle=reportData.isMaintenance ? "MR Number" : "Title"
    let formValue=reportData.isMaintenance ?  reportData.formSummary && reportData.formSummary.formId ? reportData.formSummary.formId : null : "N/A"

    return (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection
          title="Appendix 5 - Track Disturbance Report"
          {...this.props}
          centerTitle={true}
          isMaintenance={isMaintenance}
        />

        <ReportInfoSection
          fontSizeOverride={"20px"}
          rows={[
            {
              col1: {
                title: reportTitle,
                value: reportData.title,
              },
              col2: {
                title: "Form ID",
                value: formValue,
              },
            },
          ]}
        />
        <span className="spacer"></span>
        <SpecialKeyValComboBox
          data={data}
          titleAlign={"left"}
          style={{ fontSize: "20px" }}
          rows={[
            ...createGroups(
              [
                { title: "Track Disturbance Number", valId: "tdno" },
                { title: "Weld Number (if any)", valId: "weldno" },
                { title: "Sub-Division", valId: "lineName" },
                { title: "Report Date", valId: "reportDate" },
                { title: "Date of Disturbance", valId: "date" },
                { title: "Reported By", valId: "user" },
                { title: "Amendment No.", valId: "amedno" },
                { title: "Corrective Action Required", valId: "defno", formatter: (val) => TickBoxOptions(["Yes", "No"], val) },
              ],
              2,
            ).map((row) => ({ columns: row.map((property) => ({ ...property, titleColSpan: 5, valueColSpan: 5 })) })),
          ]}
        />
        <SpecialKeyValComboBox
          data={data}
          titleAlign={"left"}
          style={{ fontSize: "20px" }}
          rows={[
            { columns: [{ title: "Location", valId: "location", titleColSpan: 5, valueColSpan: 15 }] },
            ...createGroups(
              [
                { title: "Mile Post", valId: "smp" },
                { title: "To", valId: "emp" },
                { title: "Track No.", valId: "tno" },
                { title: "To", valId: "ttno" },
                { title: "N/E or S/W Rail", valId: "nerail" },
                { title: "To", valId: "swrail" },
              ],
              2,
            ).map((row) => ({ columns: row.map((property) => ({ ...property, titleColSpan: 5, valueColSpan: 5 })) })),
          ]}
        />
        <SectionHeader title={"Temperatures"} />
        <SpecialKeyValComboBox
          data={data}
          titleAlign={"left"}
          style={{ fontSize: "20px" }}
          rows={createGroups(
            [
              { title: "Air", valId: "atemp" },
              { title: "Rail (Actual)", valId: "rtemp" },
              { title: "Rail (Adjusted, if applicable see Appendix #6)", valId: "rtempa" },
            ],
            1,
          ).map((row) => ({ columns: row.map((property) => ({ ...property, titleColSpan: 10, valueColSpan: 10 })) }))}
        />

        <table className="table-bordered table-striped" style={{ fontSize: "20px" }}>
          <ReportTableSectionRenderer section={typeOfAdjustmentDisturbance} rowsData={getTypeOfAdjFormDataRows(data)} />
        </table>
      </div>
    );
  }
}

const SFRTA_TrackDisturbanceReport = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;
  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["sfrta_m_trackDisturbanceForm"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["sfrta_i_trackDisturbanceForm"]);

  return formSummaries.map((summary, _i) => (
    <ReportView
      {...props}
      reportData={{
        formSummary: summary,
        title: title,
        location: isMaintenance ? ReportGeneratorUtils.getMaintenanceLocation(inspec) : ReportGeneratorUtils.getInspectionLocation(inspec),
        subdivision: isMaintenance
          ? ReportGeneratorUtils.getMaintenanceSubdivision(inspec)
          : ReportGeneratorUtils.getInspectionSubdivision(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
        isMaintenance: isMaintenance,
      }}
    />
  ));
};

export default SFRTA_TrackDisturbanceReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/TrackDisturbanceReport/index.jsx